function normalizeEnumValue(value) {
  if (value && typeof value === 'object') {
    return normalizeEnumValue(value.value ?? value.name ?? value.code ?? value.label);
  }

  return String(value ?? '').trim().toLowerCase();
}

export function hasPlatformLogin(account) {
  const login = String(account?.login ?? '').trim();

  return login !== '' && login !== '-';
}

export function getProfileStatus(account) {
  return normalizeEnumValue(account?.profile?.status ?? account?.profileStatus ?? account?.profile_status);
}

export function isPendingVerificationAccount(account) {
  return normalizeEnumValue(account?.type) === 'live'
    && !hasPlatformLogin(account)
    && getProfileStatus(account) !== 'verified';
}

